"use strict";

exports.__esModule = true;
exports.historicalPartCount = void 0;
var _vimanaTypes = require("@vimana/vimana-types");
var historicalPartCount = exports.historicalPartCount = function historicalPartCount(translate) {
  return {
    columns: [{
      id: "deviceName",
      sortId: "device.value",
      name: translate("DataTable.Column.Title.deviceName", "Device"),
      type: "deviceName",
      enableSorting: true,
      canSearch: true
    }, {
      id: "shift",
      name: translate("DataTable.Column.Title.shift", "Shift"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partKind",
      name: translate("DataTable.Column.Title.partKind", "Part Kind"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partProcess",
      name: translate("DataTable.Column.Title.partProcess", "Part Process"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partInstance",
      name: translate("DataTable.Column.Title.partInstance", "Part Instance"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "startTime",
      name: translate("DataTable.Column.Title.startTime", "Start Time"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "endTime",
      name: translate("DataTable.Column.Title.endTime", "End Time"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "workDay",
      name: translate("DataTable.Column.Title.workDay", "Workday"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "goodPartCount",
      name: translate("DataTable.Column.Title.goodPartCount", "Good Part Count"),
      type: "string",
      enableSorting: true,
      sortMethod: function sortMethod(a, b) {
        return Number(b) - Number(a);
      }
    }, {
      id: "badPartCount",
      name: translate("DataTable.Column.Title.badPartCount", "Bad Part Count"),
      type: "string",
      enableSorting: true,
      sortMethod: function sortMethod(a, b) {
        return Number(b) - Number(a);
      }
    }],
    parseData: function parseData(responseData) {
      return {
        id: responseData.id,
        index: responseData.index,
        deviceName: responseData.device,
        shift: responseData.shift,
        partKind: responseData.partKind,
        partProcess: responseData.partProcess,
        partInstance: responseData.partInstance,
        startTime: responseData.timestampStart,
        endTime: responseData.timestampEnd,
        workday: responseData.workday,
        goodPartCount: responseData.goodPartCount,
        badPartCount: responseData.badPartCount,
        actions: responseData
      };
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: [{
          id: "deviceName",
          sortId: "device.value",
          name: translate("DataTable.Column.Title.deviceName", "Device"),
          type: "deviceName",
          enableSorting: true,
          canSearch: true
        }, {
          id: "shift",
          name: translate("DataTable.Column.Title.shift", "Shift"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "partKind",
          name: translate("DataTable.Column.Title.partKind", "Part Kind"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "partProcess",
          name: translate("DataTable.Column.Title.partProcess", "Part Process"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "partInstance",
          name: translate("DataTable.Column.Title.partInstance", "Part Instance"),
          type: "string",
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "startTime",
          name: translate("DataTable.Column.Title.startTime", "Start Time"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "endTime",
          name: translate("DataTable.Column.Title.endTime", "End Time"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "workDay",
          name: translate("DataTable.Column.Title.workDay", "Workday"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "goodPartCount",
          name: translate("DataTable.Column.Title.goodPartCount", "Good Part Count"),
          type: "string",
          enableSorting: true,
          sortMethod: function sortMethod(a, b) {
            return Number(b) - Number(a);
          }
        }, {
          id: "badPartCount",
          name: translate("DataTable.Column.Title.badPartCount", "Bad Part Count"),
          type: "string",
          enableSorting: true,
          sortMethod: function sortMethod(a, b) {
            return Number(b) - Number(a);
          }
        }]
      };
    }
  };
};